var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import FormFieldInput, {} from '../form-field-input';
import Icon from '../icon';
import { FormFieldPasswordIcon } from './styles/form-field-password.styled';
class FormFieldPassword extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            displayPassword: false,
        };
        this.toggleDisplayPassword = () => {
            this.setState(({ displayPassword }) => ({ displayPassword: !displayPassword }));
        };
    }
    render() {
        const _a = this.props, { size, reference, name, value, required, textInfo, textValidationMessages, enableDisplayPassword, colorContext } = _a, props = __rest(_a, ["size", "reference", "name", "value", "required", "textInfo", "textValidationMessages", "enableDisplayPassword", "colorContext"]);
        const { displayPassword } = this.state;
        return (_jsx(FormFieldInput, Object.assign({ autocomplete: "current-password", label: "Wachtwoord", size: size }, props, { class: "PONCHO-form-field-password", type: enableDisplayPassword && displayPassword ? 'text' : 'password', reference: reference, required: required, textInfo: textInfo, name: name, value: value, maxlength: 32, textValidationMessages: textValidationMessages, colorContext: colorContext }, (enableDisplayPassword
            ? {
                sideComponent: (_jsx(FormFieldPasswordIcon, { onClick: this.toggleDisplayPassword, tabIndex: -1, type: "button", "$colorContext": colorContext, children: _jsx(Icon, { variant: displayPassword ? 'eye-off' : 'eye', size: "lg" }) })),
            }
            : {}))));
    }
}
FormFieldPassword.defaultProps = {
    size: undefined,
    reference: 'password',
    name: 'password',
    value: '',
    required: true,
    textInfo: '',
    textValidationMessages: {
        valueMissing: 'Er is nog geen wachtwoord ingevuld.',
    },
    enableDisplayPassword: false,
};
export default FormFieldPassword;
